module.exports = __webpack_public_path__ + "static/VS_Icons_color-05-f6e004e8c5c48a8787d1fce5b870ca5d.png";